import { BaseModel } from '@/api/base-model'
import { BadgeType } from '@/api/types'
import { User } from '@/api/model/user'

export class GamificationBadge extends BaseModel<GamificationBadge> {
    protected collectionName = 'gamification_badge'

    constructor(
        public id: string,
        public year: number,
        public quarter: number,
        public type: BadgeType,
        public rank: number,
        public points: number,
        public user: User,
    ) { super(id) }

    static fromData(data: any): GamificationBadge {
        if (data === null || typeof data === 'string' || data instanceof GamificationBadge) {
            return data
        }

        return new GamificationBadge(
            data.id,
            data.year,
            data.quarter,
            data.type,
            data.rank,
            data.points,
            data.user ? User.fromData(data.user) : null,
        )
    }
}
